<template>
    <!--begin::Dashboard-->


    <div id="dnn_ctr464_ModuleContent" class="DNNModuleContent ModDNNHTMLC">
        <div id="dnn_ctr464_HtmlModule_lblContent" class="Normal">
            <div class="pageBg mt-10" data-aos="fade-up">
                <div class="container mt-20">
                    <main class="main">
                        <div class='container-fluid'>
                            <div class="min-h-700px mt-20">
                                <div class="row">
                                    <div class="col-md-12 mt-20">
                                        <div class="row mt-20">
                                            <div class="col-12">
                                                <div class="qualification_container mt-20">
                                                    <div class="qualification_tabs">
                                                        <div @click="goToPrograms"
                                                                class="qualification_button button--flex qualification_active">
                                                            <i class="uil uil-books   qualification_icon"></i>
                                                            <span class="fs-2 m-1 fw-bolder "
                                                                  style="color: #7c8b9a">{{$t('all_programs')}}</span>
                                                        </div>

                                                        <div
                                                             class="qualification_button button--flex">
                                                            <i class="uil uil-award text-danger qualification_icon"></i>
                                                            <span class="fs-2 m-1 fw-bolder  text-dark">{{$t('my_programs')}}</span>
                                                        </div>
                                                        <div @click="goToResult"
                                                             class="qualification_button button--flex">
                                                          <i class="uil uil-file qualification_icon"></i>
                                                          <span class="fs-2 m-1 fw-bolder  ">{{$t('result_page')}}</span>
                                                        </div>


                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12" v-if="loading">
                                                <div
                                                        class="row justify-content-center  mx-auto">
                                                    <div class="col-12 text-center mb-10"></div>
                                                    <div class="col-md-3 mb-10 text-center">
                                                        <card-shimmer :is-loading='true' height='10px'
                                                                      width='200px'
                                                                      color='#bdbdbd'/>
                                                    </div>
                                                    <div class="col-md-3 mb-10 text-center">
                                                        <card-shimmer :is-loading='true' height='10px'
                                                                      width='200px'
                                                                      color='#bdbdbd'/>
                                                    </div>
                                                    <div class="col-md-3 mb-10 text-center">
                                                        <card-shimmer :is-loading='true' height='10px'
                                                                      width='200px'
                                                                      color='#bdbdbd'/>
                                                    </div>
                                                    <div class="col-md-3 mb-10 text-center">
                                                        <card-shimmer :is-loading='true' height='10px'
                                                                      width='200px'
                                                                      color='#bdbdbd'/>
                                                    </div>
                                                </div>
                                            </div>

                                            <div v-if="!loading && !items.length" class="col-md-12 text-center">
                                                <div style="width: 320px;margin: auto">
                                                    <client-only>
                                                        <Vue3Lottie
                                                                animationLink="https://assets5.lottiefiles.com/packages/lf20_rc6CDU.json"
                                                        />
                                                    </client-only>
                                                </div>
                                                <br>
                                                <h4 class="mt-10">{{$t('no_data')}}</h4>
                                            </div>

                                            <div class="col-12" v-if="!loading">
                                                <ul class="linksList row large blackShadow redLink">
                                                    <li class="col-md-3" v-for="(item,key) in items">
                                                        <div data-aos="fade-left"
                                                             class="card">
                                                            <a href="javascript:void(0)"
                                                               @click="goToShowProgram(item)">
                                                                <img v-if="item.image" :src="$helpers.getImagePath(store.getters['moduleCommon/getConfigImagePath']+item.image)"
                                                                     style="filter:none !important;">
                                                                <img v-if="!item.image" style="filter:none !important;"
                                                                     :src="require('@/assets/images/no_image.png')">
                                                                <hr/>
                                                                <template v-if="item.name">
                                                                    <span v-if="i18n.locale.value == 'ar'"
                                                                          class="title">
                                                                        {{item.name ? item.name.ar : ''}}
                                                                    </span>

                                                                    <span v-if="i18n.locale.value == 'en'"
                                                                          class="title">
                                                                        <span class="icon" style="display:inline;">
                                                                            <span style="font-size: 50px;font-weight: normal;right: auto;top: 0;line-height: 0;height: 0">{{key+1}}. </span>
                                                                        </span>
                                                                    {{item.name ? item.name.en : ''}}
                                                                    </span>
                                                                </template>

                                                                <!--<template v-if="item.description">-->
                                                                <!--<div class="subtitle mb-4">-->
                                                                <!--<slot v-if="i18n.locale.value == 'ar'">-->
                                                                <!--{{item.description.ar}}-->
                                                                <!--</slot>-->
                                                                <!--<slot v-if="i18n.locale.value == 'en'">-->
                                                                <!--{{item.description.en}}-->
                                                                <!--</slot>-->
                                                                <!--</div>-->
                                                                <!--</template>-->

                                                                <!--<span type='button'-->
                                                                <!--data-bs-toggle='modal'-->
                                                                <!--data-bs-target='#show_show_modal'-->
                                                                <!--@click="showModalPrograms(item)" class="link">{{$t('apply')}}  </span>-->
                                                            </a>
                                                        </div>
                                                    </li>
                                                </ul>
                                                <hr>
                                            </div>
                                        </div>

                                        <div class="text-center justify-content-center" dir="ltr">
                                            <v-pagination
                                                    v-model="page"
                                                    :pages="totalPages"
                                                    :range-size="pageLimit"
                                                    active-color="#DCEDFF"
                                                    @update:modelValue="updateHandler"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
            <div class="cloudsTop"></div>
        </div>
        <!-- Modal -->
        <div class='modal fade' id='show_show_modal' tabindex='-1' role='dialog' ref="ModalShow"
             aria-labelledby='show_users_modalLabel' aria-hidden='true'>
            <div class='modal-dialog' role='document'>
                <div class='modal-content'>
                    <div class='modal-header'>
                        <h2 class='modal-titles text-danger' id='show_show_modalLabel'>
                            <slot v-if="i18n.locale.value == 'ar'">
                                {{currentItem ? currentItem.name.ar : ''}}
                            </slot>
                            <slot v-if="i18n.locale.value == 'en'">
                                {{currentItem ? currentItem.name.en : ''}}
                            </slot>
                        </h2>

                        <!--begin::Close-->
                        <div class='btn btn-sm btn-icon btn-active-color-primary' data-bs-dismiss='modal'>
                            <span class='svg-icon svg-icon-1'>
                              <inline-svg src='media/icons/duotune/arrows/arr061.svg'/>
                            </span>
                        </div>
                        <!--end::Close-->
                    </div>
                    <div class='modal-body'>
                        <div v-if='!currentItem'
                             class='overlay overlay-block   d-flex justify-content-center align-items-center'
                             style='min-height: 350px;position: absolute;width: 100%;height: 100%;z-index: 8;background: #fff;right: 0;'>
                                <span class='indicator-progress' style='display: block'>
                                        {{ $t('loading') }}
                                        <span class='spinner-border spinner-border-sm align-middle ms-2'></span>
                                </span>
                        </div>

                        <div v-if="currentItem">
                            <div class="min-w-350px" v-if="false">
                                <slot v-if="i18n.locale.value == 'ar'">
                                    {{currentItem.description.ar}}
                                </slot>
                                <slot v-if="i18n.locale.value == 'en'">
                                    {{currentItem.description.en}}
                                </slot>
                            </div>
                            <template v-if="currentItem.isActive && currentItem.termsAndConditions">
                                <div class="fs-6" v-if="currentItem.termsAndConditions">
                                    <!--<hr>-->
                                    <div class="fs-3 fw-bolder"> {{$t('terms')}}</div>
                                    <slot v-if="i18n.locale.value == 'ar'">
                                        <div v-html="currentItem.termsAndConditions.ar"></div>
                                    </slot>
                                    <slot v-if="i18n.locale.value == 'en'">
                                        <div v-html="currentItem.termsAndConditions.en"></div>
                                    </slot>
                                </div>
                            </template>
                            <hr v-if="currentItem.isActive" style="background-color:#ccc">
                            <label v-if="currentItem.isActive"
                                   class="form-check form-switch form-check-custom form-check-solid">
                                <input v-model="acceptTerms"
                                       class="form-check-input"
                                       name="acceptTerms"
                                       type="checkbox"
                                       value="1"/>
                                <span class="form-check-label fw-bold"
                                      :class="acceptTerms ? 'text-dark' : 'text-gray-400'"> &nbsp; {{$t('acceptTerms')}} </span>
                            </label>
                            <div v-if="!currentItem.isActive" class="bg-danger p-2 text-center text-white mt-5">
                                {{$t('unavailable')}}
                            </div>
                        </div>

                    </div>
                    <div class='modal-footer' v-if="currentItem">
                        <button v-if="currentItem.isActive" type='button' class='btn btn-sm btn-danger'
                                :disabled="!acceptTerms || !currentItem.isActive"
                                @click="goToApplyPrograms(currentItem)">
                            {{ $t('apply') }}
                        </button>
                        <button type='button' class='btn btn-sm btn-secondary' data-bs-dismiss='modal'
                                @click='currentItem=null'>
                            {{ $t('close') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <!--end::Dashboard-->
</template>

<script lang="ts">
  import { defineComponent, onMounted, reactive, toRefs, ref, unref, inject } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { useStore } from 'vuex';
  import { useI18n } from 'vue-i18n';
  import AOS from 'aos';
  import VPagination from '@hennge/vue3-pagination';
  import { hideModal } from '@/core/helpers/dom';
  import '@hennge/vue3-pagination/dist/vue3-pagination.css';
  import StorageService from '@/core/services/StorageService';

  export default defineComponent({
    name: 'all_programs',
    components: {
      VPagination,
    },
    setup() {
      const helpers: any = inject('helpers');
      const store = useStore();
      const router = useRouter();
      const i18n = useI18n();
      const { t } = useI18n();

      const ModalShow = ref<HTMLElement | null>(null);

      onMounted(() => {
        AOS.init();
        getAllPrograms();
      });

      const state = reactive({
        loading: false,
        currentItem: null,
        acceptTerms: false,
        page: 1,
        totalPages: 1,
        pageLimit: 10,
        items: [],
      });

      const updateHandler = (e) => {
        state.page = e;
        getAllPrograms();
      };
      const getAllPrograms = () => {
        state.loading = true;
        state.items = [];
        let payload = {
          paginated: true,
          limit: state.pageLimit,
          page: state.page,
        };
        setTimeout(() => {
          store.dispatch('modulePrograms/listUserPrograms', payload)
            .then(({ data }) => {
              state.loading = false;
              let response = data.data;
              state.items = response.docs;
              state.totalPages = response.totalPages;
            })
            .catch((response) => {
              state.loading = false;
              helpers.handleResponse(response, t, router, store, {});
            });
        }, 100);
      };

      const showModalPrograms = (item) => {
        state.acceptTerms = false;
        state.currentItem = item;
      };
      const goToApplyPrograms = (item) => {
        hideModal(ModalShow.value);
        // let dynamicFormsJsonWithOrder: any = item.dynamicFormsJsonWithOrder[0];
        router.push({ name: 'apply_program_page', params: { id: item._id } });
      };

      const goToPrograms = () => {
        router.push({ name: 'all_programs_page' });
      };
      const goToResult = () => {
        router.push({ name: 'my_results_page' });
      };
      const goToShowProgram = (item) => {
        state.loading = true;
        let id: any = item._id;
        store.dispatch('modulePrograms/findProgramDetails', { id: id })
          .then(({ data }) => {
            state.loading = false;
            let response = data.data;
            if (response.submissionStatus == 'NOT_COMPLETED') {
              if (response.formJsonSubmission && response.formJsonSubmission.formSubmissions) {
                console.log("apply_program_page")
                router.push({ name: 'apply_program_page', params: { id: item._id } });
                return;
              }
              console.log("show_program_page")
              router.push({ name: 'show_program_page', params: { id: item._id } });
              return;
            }
            if (response.submissionStatus == 'COMPLETED') {
              router.push({ name: 'success_program_page', params: { id: id } });
              return;
            }
          })
          .catch((response) => {
            state.loading = false;
            helpers.handleResponse(response, t, router, store, {});
          });
      };

      return {
        ...toRefs(state),
        router,
        ModalShow,
        i18n,
        store,
        goToShowProgram,
        updateHandler,
        showModalPrograms,
        goToApplyPrograms,
        goToPrograms,
        goToResult,
      };
    },
  });
</script>
<style>
    .Pagination {
        justify-content: center;
        list-style: none !important;
    }
</style>
